import React, {useEffect} from "react";
import ImageUnavailable from "./Image.unavailable";
import ImageLoading from "./Image.loading";
import {IMAGE_MIME_TYPE, LOADING_STATUS} from "utils/constants";
import FetchAttachmentBlobFunction from "components/taskdetails-remake/panels/attachments/FetchAttachmentBlob.function";
import {cacheAttachmentsImagesUrls} from "components/taskdetails-remake/taskDetails.action";
import {useDispatch, useSelector} from "react-redux";
import {Store} from "redux";
import * as reduxSelectors from "components/store/application.reducers";
import {
    getAttachmentId
} from "components/taskdetails-remake/panels/attachments/attachmentTypes/Images/Image.default.function";


export const ImageTiff = ({
                              id,
                              key,
                              zoom,
                              style,
                              src,
                              rotation,
                              collectionId,
                              uid,
                              docVersion,
                              attachmentIds
                          }: any): React.ReactElement => {
    const [loadingStatus, setLoadingStatus] = React.useState<number | null>(null);

    const imageRef = React.useRef<HTMLImageElement>(null);
    const userData = useSelector((store: Store) => reduxSelectors.getUsersData(store));
    const storedImages = useSelector((store: Store) => reduxSelectors.getImagesForRender(store));
    const dispatch = useDispatch();

    useEffect(() => {
        if (storedImages[collectionId][id]?.dsURL === "") {
            setLoadingStatus(LOADING_STATUS.LOADING);
            const attachmentIndex = Math.max(id - 1, 0);
            const attachmentId = getAttachmentId(attachmentIds, attachmentIndex);
            FetchAttachmentBlobFunction(src, IMAGE_MIME_TYPE, userData, uid, docVersion, attachmentId)
                .then((result) => {
                    if (result === null || result === undefined) {
                        setLoadingStatus(LOADING_STATUS.ERROR);
                        return;
                    }
                    dispatch(cacheAttachmentsImagesUrls(collectionId, id + 1, result));
                    drawOnCanvas(result);
                })
                .catch((error) => {
                    console.log("error");
                    console.error('Error fetching attachment:', error);
                    setLoadingStatus(LOADING_STATUS.ERROR);
                });
        }
    }, [src]);


    const drawOnCanvas = (image = storedImages[collectionId][id]?.dsURL) => {
        if (!image || image === "") return;

        try {
            // Create an ImageData object
            const imageData = new ImageData(new Uint8ClampedArray(image.buffer), image.width, image.height);
            let canvas = document.createElement('canvas');
            canvas.height = image.height;
            canvas.width = image.width
            let ctx = canvas.getContext('2d');
            ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);

            // Use the offscreen canvas as the source for the drawImage call
            ctx.putImageData(imageData, 0, 0);
            // Reset the transformation matrix to avoid cumulative scaling
            ctx.setTransform(1, 0, 0, 1, 0, 0);

            imageRef.current.src = canvas.toDataURL();
            setLoadingStatus(LOADING_STATUS.DONE);
        } catch (error) {
            setLoadingStatus(LOADING_STATUS.ERROR);
        }
    }

    useEffect(() => {
        if (storedImages[collectionId][id]?.dsURL !== "") {
            setLoadingStatus(LOADING_STATUS.LOADING);
            drawOnCanvas();
        }
    }, [zoom]);

    return (
        <div className={`images-auto-sizer__page-container page_${id}`} style={style} key={key}>
            <div className={"attachment-image-container tiff"}>
                <img
                    ref={imageRef}
                    className={`${"attachment-image"}  ${rotation ? "rotate_" + rotation : ""}`}
                    style={{width: zoom + "%"}}
                    alt={storedImages[collectionId][id]?.dsURL !== "" ? `attachment_${id}` : ``}
                    src={""}
                    role="presentation"/>

                {loadingStatus === LOADING_STATUS.ERROR &&
                    <ImageUnavailable/>
                }

                {(storedImages[collectionId] &&storedImages[collectionId][id]?.dsURL === "") || loadingStatus === LOADING_STATUS.LOADING ?
                    <ImageLoading/> : null}
            </div>
        </div>
    )
}
export default ImageTiff;